// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_O5j","cls2":"ProfileDropdown-cls2_oZz ProfileDropdown-cls1_O5j"};